import moment from "moment";
import { DATE_TIME_FORMAT_NO_SEC } from "config/constants";
export const mapProjectType = (value) => ({
  ...value,
  updatedAtLabel: value.updatedAt ? moment(value.updatedAt).format(DATE_TIME_FORMAT_NO_SEC) : "—",
  updatedByLabel: value.updatedBy?.name || "—",
});
